import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";

export const rideColumns = [
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    renderCell: (row, onEdit) => (
      <Tooltip title="Edit">
        <IconButton
          size="small"
          onClick={() => onEdit && onEdit(row)}
          className="text-primary hover:bg-primary/10"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    ),
  },
  {
    field: "id",
    headerName: "ID",
    width: 100,
  },
  {
    field: "riderFirstName",
    headerName: "Rider First Name",
    width: 150,
    renderCell: (row) => row?.rider?.firstName || "",
  },
  {
    field: "riderLastName",
    headerName: "Rider Last Name",
    width: 150,
    renderCell: (row) => row?.rider?.lastName || "",
  },
  {
    field: "transportationProviderId",
    headerName: "Transportation Provider ID",
    width: 200,
  },
  {
    field: "levelOfService",
    headerName: "Level of Service",
    width: 150,
    align: "center",
  },
  {
    field: "pickupAddress",
    headerName: "Pickup Address",
    width: 200,
    renderCell: (row) => {
      const addr = row?.pickup?.address;
      if (!addr) return "";
      return [
        addr.addressLine1,
        addr.addressLine2,
        addr.city,
        addr.state,
        addr.zipCode,
      ]
        .filter(Boolean)
        .join(", ");
    },
  },
  {
    field: "scheduleTime",
    headerName: "Schedule Time",
    width: 180,
    renderCell: (row) => {
      const dateVal = row?.dropoff?.scheduledTime || row?.pickup?.scheduledTime;
      return dateVal ? new Date(dateVal).toLocaleString() : "";
    },
  },
  {
    field: "dropoffAddress",
    headerName: "Dropoff Address",
    width: 200,
    renderCell: (row) => {
      const addr = row?.dropoff?.address;
      if (!addr) return "";
      return [
        addr.addressLine1,
        addr.addressLine2,
        addr.city,
        addr.state,
        addr.zipCode,
      ]
        .filter(Boolean)
        .join(", ");
    },
  },

  {
    field: "appointmentTime",
    headerName: "Appointment Time",
    width: 180,
    renderCell: (row) => {
      const dateVal = row?.appointmentTime;
      return dateVal ? new Date(dateVal).toLocaleString() : "";
    },
  },
  {
    field: "billableAmount",
    headerName: "Billable Amount",
    width: 120,
    align: "center",
  },
  {
    field: "billableMiles",
    headerName: "Billable Miles",
    width: 120,
    align: "center",
  },
  {
    field: "willCall",
    headerName: "Will Call",
    width: 100,
    renderCell: (row) => (row.willCall ? "Yes" : "No"),
    align: "center",
  },
  // {
  //   field: "billingRequired",
  //   headerName: "Billing Required",
  //   width: 120,
  //   align: "center",
  //   renderCell: (row) => (row.billingRequired ? "Yes" : "No"),
  // },
  // {
  //   field: "webhookURL",
  //   headerName: "Webhook URL",
  //   width: 200,
  // },
];
